<accredible-base-header *transloco="let t; lang: 'en|static' read: 'directory_corporatefinance_org.header'">

  <div identitySection>
    <img [alt]="t('cfi_logo')"
      src="assets/themes/directory.corporatefinance.org/images/cfi_logo.svg">
  </div>

  <div navigationSection>
    <sl-header-menu [extraDynamicMenuItems]="cfiHeaderLinks"></sl-header-menu>
  </div>
</accredible-base-header>
